import React, { useState } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 0.5rem;
`;

const IconButton = styled.button`
  width: 22px;
  height: 22px;
  border-radius: 999px;
  border: 1px solid ${props => props.theme.colors.border.medium};
  background: ${props => props.theme.colors.background.secondary};
  color: ${props => props.theme.colors.text.secondary};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  cursor: pointer;
  padding: 0;
  line-height: 1;

  &:hover {
    background: ${props => props.theme.colors.primary + '10'};
    color: ${props => props.theme.colors.primary};
    border-color: ${props => props.theme.colors.primary + '60'};
  }
`;

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 60;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TooltipCard = styled.div`
  width: min(460px, 92vw);
  max-height: 70vh;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 24px 60px -30px rgba(15, 23, 42, 0.7);
  border: 1px solid #e5e7eb;
  padding: 0.9rem 1rem;
  overflow-y: auto;
`;

const TooltipTitle = styled.div`
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 0.35rem;
  color: ${props => props.theme.colors.text.primary};
`;

const TooltipBody = styled.div`
  font-size: 0.8rem;
  color: ${props => props.theme.colors.text.secondary};
  line-height: 1.5;

  ul {
    margin: 0.35rem 0 0;
    padding-left: 1.1rem;
  }

  li {
    margin-bottom: 0.2rem;
  }
`;

const CloseLink = styled.button`
  margin-top: 0.35rem;
  padding: 0;
  border: none;
  background: none;
  font-size: 0.75rem;
  color: ${props => props.theme.colors.primary};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const HelpTooltip = ({ title = 'How to use this page', children, steps }) => {
  const [open, setOpen] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);

  const isWizard = Array.isArray(steps) && steps.length > 0;
  const activeStep = isWizard ? steps[Math.min(stepIndex, steps.length - 1)] : null;

  return (
    <Wrapper>
      <IconButton
        type="button"
        onClick={() => {
          setOpen(true);
          if (isWizard) setStepIndex(0);
        }}
        aria-label="Page help"
      >
        ?
      </IconButton>
      {open && (
        <Backdrop onClick={() => setOpen(false)}>
          <TooltipCard onClick={(e) => e.stopPropagation()}>
            <TooltipTitle>
              {isWizard && activeStep?.title ? activeStep.title : title}
            </TooltipTitle>
            <TooltipBody>
              {isWizard && activeStep?.content ? activeStep.content : children}
              {isWizard && steps.length > 1 && (
                <div style={{ marginTop: '0.4rem', fontSize: '0.72rem' }}>
                  Step {stepIndex + 1} of {steps.length}
                </div>
              )}
            </TooltipBody>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '0.35rem' }}>
              {isWizard && steps.length > 1 ? (
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <CloseLink
                    type="button"
                    onClick={() => setStepIndex(prev => Math.max(0, prev - 1))}
                    disabled={stepIndex === 0}
                    style={{ opacity: stepIndex === 0 ? 0.4 : 1 }}
                  >
                    Previous
                  </CloseLink>
                  <CloseLink
                    type="button"
                    onClick={() => setStepIndex(prev => (prev + 1 < steps.length ? prev + 1 : prev))}
                    disabled={stepIndex + 1 >= steps.length}
                    style={{ opacity: stepIndex + 1 >= steps.length ? 0.4 : 1 }}
                  >
                    Next
                  </CloseLink>
                </div>
              ) : (
                <span />
              )}
              <CloseLink type="button" onClick={() => setOpen(false)}>
                Got it
              </CloseLink>
            </div>
          </TooltipCard>
        </Backdrop>
      )}
    </Wrapper>
  );
};

export default HelpTooltip;


